(function () {
  var STORAGE_KEY = "web-last-lamp-v1";

  function boot() {
    var root = document.querySelector('.puzzle-page[data-puzzle="last-lamp"]');
    if (!root || root.getAttribute("data-booted") === "1") return;
    root.setAttribute("data-booted", "1");
    startPuzzle(root);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  function startPuzzle(root) {
    function q(id) { return root.querySelector("#" + id); }

    var nodes = {
      dek: q("dek"),
      caseSeed: q("case-seed"),
      letter: q("letter"),
      stack: q("stack"),
      check: q("check"),
      reveal: q("reveal"),
      status: q("status"),
      newCase: q("new-case"),
      modal: q("modal"),
      modalYes: q("modal-yes"),
      modalNo: q("modal-no"),
      spoil: q("spoil"),
      spoilYes: q("spoil-yes"),
      spoilNo: q("spoil-no"),
    };

    var state = null;

    function lamp() {
      var api = globalThis.LastLamp;
      if (!api) throw new Error("LastLamp is missing");
      return api;
    }

    function setStatus(text, kind) {
      nodes.status.textContent = text;
      nodes.status.className = kind || "";
    }

    function randomSeed() {
      var buf = new Uint32Array(1);
      crypto.getRandomValues(buf);
      return buf[0] || 1;
    }

    function fresh(seed) {
      var made = lamp().createCase(seed);
      return {
        version: 1,
        seed: made.seed,
        dealt: made.dealt.slice(),
        order: made.dealt.slice(),
        checkedOnce: false,
        revealed: false,
      };
    }

    function load() {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.dealt) || !Array.isArray(parsed.order)) return null;
      var made = fresh(parsed.seed);
      if (!lamp().sameOrder(made.dealt, parsed.dealt)) return null;
      if (!lamp().sameOrder(parsed.order.slice().sort(function (a, b) { return a - b; }), lamp().trueOrder())) return null;
      made.order = parsed.order.slice();
      made.checkedOnce = !!parsed.checkedOnce;
      made.revealed = !!parsed.revealed;
      return made;
    }

    function save() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        version: 1,
        seed: state.seed,
        dealt: state.dealt,
        order: state.order,
        checkedOnce: state.checkedOnce,
        revealed: state.revealed,
      }));
    }

    function hasWork() {
      return state.checkedOnce || state.revealed || !lamp().sameOrder(state.order, state.dealt);
    }

    function renderLetter() {
      nodes.letter.replaceChildren();
      lamp().introParagraphs.forEach(function (text) {
        var p = document.createElement("p");
        p.textContent = text;
        nodes.letter.append(p);
      });
    }

    function render() {
      var api = lamp();
      nodes.caseSeed.textContent = "Case " + api.caseLabel(state.seed);
      nodes.check.disabled = state.revealed;
      nodes.reveal.hidden = state.revealed;
      nodes.stack.replaceChildren();
      state.order.forEach(function (id, index) {
        var page = api.pageById(id);
        var card = document.createElement("article");
        card.className = "card";
        var moves = document.createElement("div");
        moves.className = "moves";
        var up = document.createElement("button");
        up.type = "button";
        up.textContent = "Up";
        up.disabled = state.revealed || index === 0;
        up.setAttribute("aria-label", "Move earlier: " + api.lead(id));
        up.addEventListener("click", function () { move(index, -1); });
        var down = document.createElement("button");
        down.type = "button";
        down.textContent = "Down";
        down.disabled = state.revealed || index === state.order.length - 1;
        down.setAttribute("aria-label", "Move later: " + api.lead(id));
        down.addEventListener("click", function () { move(index, 1); });
        moves.append(up, down);
        var copy = document.createElement("p");
        copy.textContent = page.text;
        card.append(moves, copy);
        nodes.stack.append(card);
      });
    }

    function move(index, delta) {
      var next = index + delta;
      if (next < 0 || next >= state.order.length || state.revealed) return;
      var tmp = state.order[index];
      state.order[index] = state.order[next];
      state.order[next] = tmp;
      save();
      render();
    }

    function deal(seed) {
      state = fresh(seed);
      save();
      setStatus("", "");
      render();
    }

    function openModal() {
      nodes.modal.hidden = false;
      nodes.modalNo.focus();
    }

    function closeModal() {
      nodes.modal.hidden = true;
      nodes.newCase.focus();
    }

    function openSpoil() {
      nodes.spoil.hidden = false;
      nodes.spoilNo.focus();
    }

    function closeSpoil() {
      nodes.spoil.hidden = true;
      if (!nodes.reveal.hidden) nodes.reveal.focus();
    }

    nodes.check.addEventListener("click", function () {
      if (state.revealed) return;
      state.checkedOnce = true;
      if (lamp().sameOrder(state.order, lamp().trueOrder())) {
        state.revealed = true;
        setStatus("Yes. That is the order of the evening.", "ok");
      } else {
        setStatus("No. The evening does not read in that order.", "bad");
      }
      save();
      render();
    });

    nodes.reveal.addEventListener("click", openSpoil);
    nodes.spoilYes.addEventListener("click", function () {
      closeSpoil();
      state.order = lamp().trueOrder();
      state.revealed = true;
      setStatus("That is the order of the evening.", "ok");
      save();
      render();
    });
    nodes.spoilNo.addEventListener("click", closeSpoil);
    nodes.spoil.addEventListener("click", function (event) {
      if (event.target === nodes.spoil) closeSpoil();
    });

    nodes.newCase.addEventListener("click", function () {
      if (hasWork()) openModal();
      else deal(randomSeed());
    });

    nodes.modalYes.addEventListener("click", function () {
      closeModal();
      deal(randomSeed());
    });

    nodes.modalNo.addEventListener("click", closeModal);
    nodes.modal.addEventListener("click", function (event) {
      if (event.target === nodes.modal) closeModal();
    });

    root.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (!nodes.spoil.hidden) closeSpoil();
      else if (!nodes.modal.hidden) closeModal();
    });

    nodes.dek.textContent = lamp().DEK;
    renderLetter();
    try { state = load(); } catch (err) { state = null; }
    if (!state) state = fresh(randomSeed());
    save();
    render();
    if (state.revealed) setStatus("That is the order of the evening.", "ok");
  }
})();
